module.exports = __webpack_public_path__ + "img/secondary_8x3_z18.9c7f12a6.svg";